import { useContext } from 'react';
import { SetupFlowStepContext } from 'accounts/contexts/setup-flow-step';

export function useSetupFlowStep() {
  const flowStep = useContext(SetupFlowStepContext);

  // Every consumer renders underneath `SetupFlowStepProvider`; the `undefined`
  // default exists only because `createContext` requires one. Asserting it here
  // is what keeps all 27 call sites — each of which destructures the result
  // immediately, and so already throws if it were absent — from having to guard
  // a value that is always present.
  return flowStep!;
}
